import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

import { courseTheme } from "@/lib/training/courseTheme";

// Shared kicker / title / lede header used by the howItWorks, video, and
// content screens (CPR_Course_Module1.html .kicker / .title / .lede).

export function ScreenHeader({
    kicker,
    title,
    lede
}: {
    kicker: string;
    title: string;
    lede: string;
}) {
    return (
        <View>
            <Text style={styles.kicker}>{kicker}</Text>
            <Text style={styles.title}>{title}</Text>
            <Text style={styles.lede}>{lede}</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    kicker: {
        fontSize: 12,
        fontWeight: "700",
        letterSpacing: 0.4,
        textTransform: "uppercase",
        color: courseTheme.tealD,
        marginBottom: 6
    },
    title: { fontSize: 23, fontWeight: "800", color: courseTheme.navy, lineHeight: 29 },
    lede: { fontSize: 14.5, lineHeight: 21, color: courseTheme.slate, marginTop: 8 }
});
